import {defineAsyncComponent} from 'vue';

export {default as CollectionBanner} from './CollectionBanner.vue';
export {default as CollectionGrid} from './CollectionGrid.vue';
export {default as CollectionColumnDisplay} from './CollectionColumnDisplay.vue';

export const CollectionFilter = defineAsyncComponent(() => import('./CollectionFilter.vue'));
export const TriggerLoadMore = defineAsyncComponent(() => import('./TriggerLoadMore.vue'));
export const QuickMenuFilter = defineAsyncComponent(() => import('./QuickMenuFilter.vue'));
